import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconArrowRight, IconLocation, IconPrinter } from '@redteclab/icons'

import { Button } from 'base-ui'

import {
  DirectContactFaxDialog,
  DirectContactPostCardDialog,
} from '../../direct-contact'
import { useOpenableControls } from '../../generic-hooks'
import { useGlobalConfigContext } from '../../global-config'
import { TENANT } from '../../tenant'

export const ContactPageDirectContactInformationSection: FC = () => {
  const modalControlsPostDialog = useOpenableControls()
  const modalControlsFaxDialog = useOpenableControls()

  const { tenant } = useGlobalConfigContext()

  if (tenant !== TENANT.COM) {
    return null
  }

  return (
    <div className="bg-light-primary-low tablet:py-12">
      <div className="container flex flex-wrap place-content-center gap-4 bg-light-primary-medium px-4 py-9 tablet:rounded-2xl tablet:py-12">
        <h2 className="w-full text-start text-xl font-medium text-dark-primary-max tablet:text-center">
          <FormattedMessage id="contact.directContactSection.postOrFax.title" />
        </h2>
        <p className="w-full text-start font-normal text-dark-primary-strong tablet:text-center">
          <FormattedMessage id="contact.directContactSection.postOrFax.description" />
        </p>
        <div className="flex w-full flex-col gap-6 rounded-2xl border border-dark-primary-min p-6 tablet:w-2/3">
          <Button
            color="secondary"
            data-qa-id="contact.page.post.label"
            endIcon={<IconArrowRight />}
            id="contact.page.post.label"
            onClick={() => {
              modalControlsPostDialog.handleOpen()
            }}
            size="large"
            startIcon={<IconLocation />}
            variant="text"
          >
            <p className="ml-1 w-full text-start text-dark-primary-max">
              <FormattedMessage id="helpCentre.contact.button" />
            </p>
          </Button>
          <Button
            color="secondary"
            data-qa-id="contact.page.fax.label"
            endIcon={<IconArrowRight />}
            id="contact.page.fax.label"
            onClick={() => {
              modalControlsFaxDialog.handleOpen()
            }}
            size="large"
            startIcon={<IconPrinter />}
            variant="text"
          >
            <p className="ml-1 w-full text-start text-dark-primary-max">
              <FormattedMessage id="contact.directContactSection.fax.cta.label" />
            </p>
          </Button>
        </div>
        <DirectContactPostCardDialog
          onClose={modalControlsPostDialog.handleClose}
          open={modalControlsPostDialog.isOpen}
        />
        <DirectContactFaxDialog
          onClose={modalControlsFaxDialog.handleClose}
          open={modalControlsFaxDialog.isOpen}
        />
      </div>
    </div>
  )
}
